<template>
    <van-button size="small"
        type="primary"
        class="btn-blue"
        style="width:47vw;"
        :disabled="disabled"
        @click="onClick">
        <slot/>
    </van-button>
</template>

<script>
export default {
    name : 'MobileSubmitButton',

    data() {
        return {
            disabled : false
        }
    },

    methods : {
        onClick(e) {
            this.$emit('click', e);
        },

        enable() {
            console.log('#28 enable', this);

            this.disabled = false;
        },

        disable() {
            console.log('#34 disable', this);

            this.disabled = true;
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileSubmitButton.vue